import { contentManagementService } from '../../../service';
import _ from 'lodash';
import moment from "moment";
import { getFormatedDate } from '../../treeComponents/helper';
import { ACADEMIC_YEAR } from '../../../../../constants/comman';

export enum WEEK_FORMAT  {
    MON_TO_SUN = 'mondayToSunday',
    WEEKLY = 'weekly'
  };

  export enum WEEK_FORMAT_LABEL  {
    MON_TO_SUN = 'Monday to Sunday',
    WEEKLY = 'Weekly'
  };  

export const setSubjectState = (props: any) => {
    const { courseSyllabus = [],setCoursePlanStates,coursePlanState } = props;
    let oldState = {...coursePlanState};
    let subjects = courseSyllabus.filter((syllabusData: any) => syllabusData.type === "subject");
    let subjectArr: any = [];
    subjects.forEach((subject: any) => {

        let chapters = courseSyllabus.filter((syllabusData: any) => syllabusData.type === "chapter" && syllabusData.ancestors.includes(subject._id));
        subjectArr.push({ name: subject.name,masterId:subject.masterIDs[0] ,chapterCount: chapters.length, chaptersData: chapters });

    });
    oldState.subjects = subjectArr;
    setCoursePlanStates({coursePlanState:{...coursePlanState,...oldState}});
}


export const createCoursePlanPayload =  (props: any) =>{

    const {phases,setCoursePlanStates,coursePlanState,totalSubjectChapters,setChaptersSubject} = props;
    let oldPhases = {...phases};
    let phaseArr: any = [];
    let oldState = {...coursePlanState};
    let totalWeekCount:any = 0;
    let returnData: any = {};
    let totalSubjectChaptersStateData: any = [];
    let cloneTotalSubjectChapters = JSON.parse(JSON.stringify(totalSubjectChapters));

   // if(cloneTotalSubjectChapters.length > 0){
        Object.keys(oldPhases).forEach((item: any) => {
            const { phaseName = "", subject = {}, startDate = "", endDate = "", isRevision, isActive } = oldPhases[item];
            let subjectCountArr = createSubjectCountObj(subject,props);
            let phaseWeek = convertPhasesInToWeeks(startDate, endDate, coursePlanState.weekFormat);
            
            if (isRevision) {
                let weekData = revisionWheekDistribution(phaseWeek, totalWeekCount);

                const { returWeekCount, subjectWiseChapter = [] } = weekData;
                totalWeekCount = returWeekCount;
                phaseArr.push({ name: phaseName, startDate : moment(startDate).format('YYYY-MM-DD'), endDate : moment(endDate).format('YYYY-MM-DD'), milestoneTests: [], subjects: subjectCountArr,isRevision: true, weeks: subjectWiseChapter, isActive });

            } else {
                
                let weekData = chaptersDividedPerWeek(phaseWeek, subjectCountArr, props, totalWeekCount, cloneTotalSubjectChapters);
               
                const { returWeekCount, subjectWiseChapter = [], cloneTotalSubjectChapters: totalSubjectChaptersStateData } = weekData;
                totalWeekCount = returWeekCount;
                phaseArr.push({ name: phaseName, startDate : moment(startDate).format('YYYY-MM-DD'), endDate : moment(endDate).format('YYYY-MM-DD'),  milestoneTests: [], subjects: subjectCountArr,isRevision: false, weeks: subjectWiseChapter, isActive });
            }
        });

       oldState.phases = phaseArr;
       oldState.totalPhases = Object.keys(oldPhases).length;
       setChaptersSubject({totalSubjectChapters:totalSubjectChaptersStateData});
       setCoursePlanStates({coursePlanState:{...coursePlanState,...oldState}});
      returnData = contentManagementService.createCoursePlan(oldState).then((response: any) => {
          return response;
      });

    return returnData;
}

const revisionWheekDistribution = (phaseWeek:any,totalWeekCount: any) =>{

    let weekRangeArray: any =[];
    phaseWeek && phaseWeek.map((item:any) => {
        totalWeekCount++;
        const {startDate="",endDate ="",} = item;
        weekRangeArray.push({ weekNo: totalWeekCount, startDate,endDate, subjects: [], content: [] });

    });

    let returnData = { returWeekCount: totalWeekCount, subjectWiseChapter:weekRangeArray }

    return returnData;
}

const chaptersDividedPerWeek = (weeksRange: any, subjectPerPhase: any, props: any, totalWeekCount: any, totalSubjectChapters: any) => {

    const { courseSyllabus = [],isGoalCombo} = props;
    let subjectWiseChapter: any = [];
    let weekNo: any = 1;
      weeksRange.map((weekData: any) => {

            totalWeekCount++;
            let weekSubjectData: any = [];
            subjectPerPhase.map((item: any) => {
                
                const { chapterCount, name, id } = item;
                let subjectData = totalSubjectChapters.find((subject: any) => subject.name === name);
                let subjectDataIndex = totalSubjectChapters.findIndex((subject: any) => subject.name === name);

                const { courseId = "", _id = "", chaptersData = [] } = subjectData;
                let subjectDataObj = { name, id, courseSyllabusIds: [{ courseId, syllabusId: _id }], chapters: [] };
                
                let chaptersArr: any = [];
                if (chapterCount > 0) {

                    let chapterPerWeek = Math.floor(Number(chapterCount) / weeksRange.length);
                    chapterPerWeek = chapterPerWeek < 1 ? 1:chapterPerWeek;
                   if (Number(chapterCount) % weeksRange.length !== 0) {
                        if (weekNo === weeksRange.length) {
                            chapterPerWeek = Number(chapterCount) - (chapterPerWeek * (weeksRange.length - 1));
                        }
                    }
                   
                    for (let i = 0; i < chapterPerWeek; i++) {
                        let chapter = chaptersData[i];
                        
                        if (chapter && !isGoalCombo) {
                          chaptersArr.push({ name: chapter.name, id: chapter.masterIDs[0], courseSyllabusIds: [{ courseId: chapter.courseId, syllabusId: chapter._id }], content: [], concepts: getConceptByChapterId(chapter._id, courseSyllabus) });
                        } else if (chapter && isGoalCombo) {
                          const { chapData, chapterConcepts } = chapter;
                          chaptersArr.push({ name: chapData.name, id: chapData.masterIDs[0], courseSyllabusIds: [{ courseId: chapData.courseId, syllabusId: chapData._id }], content: [], concepts: chapterConcepts });

                        }
                    }

                    subjectDataObj.chapters = chaptersArr;
                    totalSubjectChapters[subjectDataIndex].chaptersData.splice(0, chapterPerWeek);
                }

                weekSubjectData.push(subjectDataObj);
            })

            let fullWeekdata = { weekNo: totalWeekCount, startDate: weekData.startDate, endDate: weekData.endDate, subjects: weekSubjectData, content: [] }

            subjectWiseChapter.push(fullWeekdata);
            weekNo++;

        });
   return { returWeekCount: totalWeekCount, subjectWiseChapter, cloneTotalSubjectChapters: totalSubjectChapters };
}


export const createSubjectCountObj = (subjects: any,props:any) =>{
    const {totalSubjectChapters} = props;

    let subjectArr: any = [];
    Object.entries(subjects).forEach((subItem:any, index:any) =>{
        const [key] =Object.entries(subItem[1]);
        let subjectData = totalSubjectChapters.find((subject: any) => subject.name === key[0]);
        let keyName: any = key[0];
        let value: any = key[1];
        if(subjectData){
            subjectArr.push({name:keyName,chapterCount:value,id:subjectData.id});
        }
    });

    return subjectArr;
}

export const getConceptByChapterId = (chapterId:any,courseSyllabus:any) =>{
    let formatedConcept: any =[]; 
    let conceptArray = courseSyllabus.filter((syllabusData: any) => syllabusData.type === "concept" && syllabusData.ancestors.includes(chapterId));
    
    conceptArray.map((concept: any)=>{
        formatedConcept.push({name:concept.name,id:concept.masterIDs[0],courseSyllabusIds:[{courseId:concept.courseId,syllabusId:concept._id}],content: []});
    })

    return formatedConcept;
}

export const convertPhasesInToWeeks = (startDate: any, endDate: any, weekFormate: any) => {

    let dateRangeArr: any = [];
    if (weekFormate === WEEK_FORMAT.WEEKLY) {
        let rangeArr: any = [];
        dateRangeArr = dateRangRecursive(startDate, endDate, rangeArr);
    } else if (weekFormate === WEEK_FORMAT.MON_TO_SUN) {
        dateRangeArr = mondayToSundayFormat(startDate, endDate);
    }
    return dateRangeArr;
}


export const dateRangRecursive = (startDate: any, endDate: any,rangeArr:any) => {

    if(new Date(startDate) < new Date(endDate)){
        let newEndDate :any= moment(startDate, "YYYY-MM-DD").add(6, 'days').format("YYYY-MM-DD");
        
        if(new Date(endDate) <  new Date(newEndDate)){
            newEndDate = endDate;
        }

        rangeArr.push({startDate:startDate,endDate:newEndDate});
        newEndDate = moment(newEndDate, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
        let newStartDate: any = newEndDate  
        dateRangRecursive(newStartDate,endDate,rangeArr);
       return rangeArr;
    }else{
        return rangeArr;
    }
}

export const mondayToSundayFormat = (startDate: any, endDate: any) =>{

    const date = moment(startDate,"YYYY-MM-DD"); 
    const weekDayNumber = date.day();

    let firstWeek = {};
    let newEndDate = "";
    if(weekDayNumber === 0){
         firstWeek = {startDate:startDate,endDate:startDate};
         newEndDate = moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    }else{
        let nearestSunday = 7 - weekDayNumber;
         newEndDate = moment(startDate, "YYYY-MM-DD").add((nearestSunday), 'days').format("YYYY-MM-DD");
         if(moment(newEndDate).diff(moment(endDate),'days')  > 0){
             newEndDate = endDate;
          }
         firstWeek = {startDate:startDate,endDate:newEndDate};
    }
    
    let rangeArr: any = [];
    let dateRangeArr = dateRangRecursive(moment(newEndDate, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD"),endDate,rangeArr);

    dateRangeArr.unshift(firstWeek);
    return dateRangeArr;
}



export const dateFormater = (date:any) =>{
    //Oct 20 2010
    return moment(date,"YYYY-MM-DD").format("MMM D YYYY")
}

export const checkBetweenDate = (date: any, startDate: any, endDate: any) => {
    
    let startDateUTC = getFormatedDate(startDate).join(" ");
    let endDateUTC = getFormatedDate(endDate).join(" ");
    let dateUTC = getFormatedDate(date).join(" ");

    if( moment(dateUTC, "DD MMM YYYY").isBetween(moment(startDateUTC, "DD MMM YYYY").subtract(1, 'days'),  moment(endDateUTC, "DD MMM YYYY").add(1, 'days'))){
     return true;
   }
    return false;
}

export const checkTotalChapterDistributed = (props: any) => {

    const { totalSubjectChapters, addedChapterCount } = props;
    const { phases } = props;
    let isTotalDistributed: any = true;
    Object.entries(addedChapterCount).forEach((subItem: any, index: any) => {

        const [key] = Object.entries(subItem[1]);
        let subjectData = totalSubjectChapters.find((subject: any) => subject.name === key[0]);
       
        if (subjectData) {
            const { chapterCount = 0 } = subjectData;
            let keyName: any = key[0];
            let value: any = key[1];
           
            if (chapterCount !== Number(value)) {
                isTotalDistributed = false;
            }
        }
    });
    return isTotalDistributed;
}

export const checkPhaseData = (props: any) =>{
  const {phases} = props;
  let isValidateDate: any = false;
  let checkPhaseDate= Object.values(phases).find((phase: any) => phase.phaseName ==='' || phase.startDate === '' || phase.endDate === '');
   
  if(typeof checkPhaseDate === 'undefined'){
    isValidateDate= true
  }
  return isValidateDate;
} 

export const mergeGoalsForComboCourse =  async (props: any,packageObj: any) =>{

    const { responseObject = {} } = packageObj;
    const { packageData = {} } = responseObject;
    const { courseDetails = [], type = '', startDate = '', expiryDate = '' } = packageData;
    const {match: { params: { id = '' }, },coursePlanState } = props;

    const overAllData = courseDetails.map((courseData: any) => {
        const {courseId} = courseData;
        
        if(courseData.primary){
          return goalWiseFormatedChapter(courseId).then((response)=>{
            return Promise.resolve({primaryData: response});
          })
        }else{
          return goalWiseFormatedChapter(courseId).then((response)=>{
            return Promise.resolve({nonPrimaryData: response});
          })
        }
    });

    let returnData =  Promise.all(overAllData).then((value: any) => {
        let primaryGoalData: any = [];
        let nonPrimaryGoalData: any = [];
        value.forEach((ele: any) => {
          if (ele.hasOwnProperty('primaryData')) {
            primaryGoalData.push(ele.primaryData);
      
          } else {
            nonPrimaryGoalData.push(ele.nonPrimaryData);
          }
        })
      let mergedData:any  =  mergeSubjectData(primaryGoalData[0],nonPrimaryGoalData,props);
      //console.log( 'mergedData', mergedData );
      props.setChaptersSubject({
        totalSubjectChapters: [...mergedData],
      });
      return mergedData;
    });
    return returnData;
}

export const mergeSubjectData = (primaryCourseData: any,nonPrimaryGoalArr:any,props:any) => {
  //console.log( 'inputs',  primaryCourseData, nonPrimaryGoalArr, props );
  let primaryCourseDataClone = [...primaryCourseData];
  let goleWiseMatchData :any = [];

   nonPrimaryGoalArr.map((item: any) =>{
        let matchedData : any =[];
        item.map((npData:any) => {
           
            let subjectData = primaryCourseDataClone.find((subject: any) => subject.name === npData.name);
            if(typeof subjectData !== "undefined"){
                matchedData.push(npData);
            }else{
                primaryCourseDataClone.push(npData);
            }
        });
      goleWiseMatchData.push(...matchedData);
    });
    
    let primaryCourseDataPrm = JSON.parse(JSON.stringify(primaryCourseDataClone));
    let goleWiseMatchDataPrm = JSON.parse(JSON.stringify(goleWiseMatchData));
    let returnData =  mergeChaptersSubjectWise(primaryCourseDataPrm,goleWiseMatchDataPrm,props);
    //console.log('output', returnData);
    return returnData;
}

export const mergeChaptersSubjectWise = (primaryData:any,matchedData:any,props:any) =>{
    //console.log( 'mergeChaptersSubjectWise', primaryData, matchedData )
    let primaryDataClone = JSON.parse(JSON.stringify(primaryData));
    if(matchedData && matchedData.length > 0){
        
        matchedData.map((match:any)=>{
            let mergedChapData : any =[];
            let subjectData = primaryDataClone.find((subject: any) => subject.name === match.name);
            let subjectDataIndex = primaryDataClone.findIndex((subject: any) => subject.name === match.name);

            if (typeof subjectData !== "undefined") {
                let primaryChaptersData = primaryDataClone[subjectDataIndex].chaptersData;
                let matchedChaptersData = match.chaptersData;
                let matchedChaptersDataClone = [...match.chaptersData];
                let count = 1;
                
                primaryChaptersData.forEach((primaryChap: any, index: any) => {
                    mergedChapData.push(primaryChap);
                        count++;  
                });
                matchedChaptersData.forEach((matchChapterData: any) => {
                  let findChapter = primaryChaptersData.find((subject: any) => subject.chapData && subject.chapData.name === matchChapterData.chapData.name);
                  if (!findChapter) {
                    mergedChapData.push(matchChapterData);
                  }
                });
               /*
                if(matchedChaptersData.length > primaryChaptersData.length){
                   let slicedData = matchedChaptersDataClone.slice(primaryChaptersData.length);
                   let returnedSliced = checkSlicedData(mergedChapData,slicedData);
                    mergedChapData.push(...returnedSliced);
                }
                */
                primaryDataClone[subjectDataIndex].chapterCount = mergedChapData.length;
                primaryDataClone[subjectDataIndex].chaptersData = mergedChapData;
            }
        });
        
        // props.setChaptersSubject({
        //   totalSubjectChapters: [...primaryDataClone],
        // });
        //console.log( 'output2', primaryDataClone );
      }
      return primaryDataClone;
}

export const checkSlicedData = (primaryData: any,slicedData: any) =>{

  let uniqueChapterData: any = [];
  slicedData.map((item: any) =>{

  let findChapter = primaryData.find((subject: any) => subject.chapData && subject.chapData.name === item.chapData.name);

    if (typeof findChapter === "undefined") {
      uniqueChapterData.push(item);
    } 
  });
  return [...primaryData,...uniqueChapterData];
}

export const goalWiseFormatedChapter = async (courseId:any) =>{
    let subjectArr: any = [];
    let subjectChaptersArr: any = [];

    let returnData =   await contentManagementService.getCourseSyllabus(courseId).then((res: any) => {
        let syllabusResult = res;
        let subjects = syllabusResult.filter(
          (syllabusData: any) => syllabusData.type === 'subject'
        );
        
        subjects.forEach((subject: any) => {
          let chapters = syllabusResult.filter(
            (syllabusData: any) =>
              syllabusData.type === 'chapter' && syllabusData.ancestors.includes(subject._id)
          );
          
          let chaptersArr:any = []; 
          chapters.forEach((chapData :any) => {
            chaptersArr.push({chapData,chapterConcepts:getConceptByChapterId(chapData._id,syllabusResult)})
          });

          let sortedChapter = handleChapterSequence(chaptersArr);

          subjectArr.push({
            id: subject.masterIDs[0],
            name: subject.name,
            chapterCount: chapters.length,
          });

          subjectChaptersArr.push({
            id: subject.masterIDs[0],
            _id: subject._id,
            courseId: subject.courseId,
            name: subject.name,
            chapterCount: chapters.length,
            chaptersData: sortedChapter,
            });
          });

          return subjectChaptersArr;
         // return Promise.resolve(subjectChaptersArr);
        });

      return returnData;
}

export const getCoursePlanById = ( coursePlanId: any, setCoursePlanResponse: any, handleLoadingStatus : any ) => {
  contentManagementService.getCousePlanApiById(coursePlanId).then(({ coursePlan }: any) => {
    setCoursePlanResponse({
      coursePlanResponse: coursePlan
    });
    handleLoadingStatus();
  });
}

export const handleWeekSelect = (event: any, props: any) => {
  const { setCoursePlanStates, coursePlanState, checkWeek, setCheckWeek, phases } = props;
  let oldState = { ...coursePlanState };
  //console.log({phases});
  //console.log({phasesData:phases.phase1.startDate});
  // //console.log({checkWeek:checkWeek});
  // //console.log({checkWeek:!checkWeek});
  let phaseValue: any = Object.values(phases).filter((phase: any) => phase.startDate !== '' && phase.endDate !== '')
  let phaseLen: any = phaseValue.length;
  
  if( phaseLen >= 1 && Object.keys(phases).length >= phaseLen){

    let updateCheckWeek =  !checkWeek;
    setCheckWeek({checkWeek: updateCheckWeek});
    //console.log({checkWeek:updateCheckWeek});
  }
  

  //setTimeout(() =>{ //console.log({checkWeek}); },4000);
  //alert("huuuu")
  // if(oldState.weekFormat!== event.target.value)
  // {
  //   setCheckWeek({checkWeek: true})
  // }
  // setCheckWeek({checkWeek: false})

  
  oldState.weekFormat = event.target.value;

  setCoursePlanStates({ coursePlanState: { ...coursePlanState, ...oldState } });
};


export const onConfirmChangeWeekFormate = (props: any) =>{

  const { setCoursePlanStates, coursePlanState, checkWeek, setCheckWeek, phases,setPhaseData } = props;

  let fullOldPhases = { ...phases };
 let newPhases:any = [];
////console.log({fullOldPhases});
  Object.keys(fullOldPhases).map((item:any) => {
    //console.log({item:fullOldPhases[item]});
    //fullOldPhases[item];

    newPhases[item] = {...fullOldPhases[item],startDate:"",endDate:""}
  });
  //console.log({newPhases});

  setPhaseData({ phases: { ...newPhases } });
  setCheckWeek({checkWeek: false});
  //cancelChangeWeekFormate(props);
}

export const cancelChangeWeekFormate = (props: any) => {

  const { setCoursePlanStates, coursePlanState, checkWeek, setCheckWeek, phases } = props;
  let oldState = { ...coursePlanState };

  let weekFormate = WEEK_FORMAT_LABEL.MON_TO_SUN;
   if(oldState.weekFormat === WEEK_FORMAT_LABEL.WEEKLY)
  {
    weekFormate = WEEK_FORMAT_LABEL.MON_TO_SUN;
  }else if(oldState.weekFormat === WEEK_FORMAT_LABEL.MON_TO_SUN){
    weekFormate = WEEK_FORMAT_LABEL.WEEKLY;
  }
  
  oldState.weekFormat = weekFormate;

  setCoursePlanStates({ coursePlanState: { ...coursePlanState, ...oldState } });
  setCheckWeek({checkWeek: false});
  
}

export const checkWeekFormat = (event: any, props: any) => {
  const { setCoursePlanStates, coursePlanState, checkWeek, setCheckWeek  } = props;
  let oldState = { ...coursePlanState };
  const week: any= oldState.weekFormat;
  //alert('hiii');
  //console.log({checkWeek});
  // if(week === event.target.value)
  // {
  //   setCheckWeek({checkWeek: false})
  // }
  // setCheckWeek({checkWeek: true})
}

export const checkChapterCount = (keyName: any, props: any) => {
  const { phases, setchapterCount, addedChapterCount, coursePlanState, showMsg, } = props;
  const { subjects: subjectDetail = [] } = coursePlanState;
  let oldPhases = { ...phases };
  let totalValue: any = 0;
  Object.keys(oldPhases).forEach((item: any, indexId: any) => {
    const { subject = {} } = oldPhases[item];
    let subIndex = subject.findIndex((subItem: any) => subItem.hasOwnProperty(keyName));
    totalValue += parseInt(subject[subIndex][keyName]);
  });
  let subjectName: any = keyName[0];
  let subjectCount = subjectDetail.filter((subjectData: any) => subjectData.name === subjectName);

  let recivedTotalCount = subjectCount[0]['chapterCount'];

  if (totalValue > recivedTotalCount) {
    showMsg(
      `Minimum ${recivedTotalCount} chapter(s) should be added atleast in subject of ${subjectName}`,
      'error'
    );
  }
}


export const manageChapterCount = (keyName: any, props: any) => {

    const { phases, setchapterCount, addedChapterCount, coursePlanState, showMsg, } = props;
    const { subjects: subjectDetail = [] } = coursePlanState;
    let oldPhases = { ...phases };
    let totalValue: any = 0;
    Object.keys(oldPhases).forEach((item: any, indexId: any) => {
      const { subject = {} } = oldPhases[item];
      let subIndex = subject.findIndex((subItem: any) => subItem.hasOwnProperty(keyName));
      totalValue += parseInt(subject[subIndex][keyName]);
    });
    let subjectName: any = keyName[0];
    let subjectCount = subjectDetail.filter((subjectData: any) => subjectData.name === subjectName);

    //let recivedTotalCount = subjectCount[0]['chapterCount'];
    // if (totalValue > recivedTotalCount) {
    //   showMsg(
    //     `Minimum ${recivedTotalCount} chapter(s) should be added atleast in subject of ${subjectName}`,
    //     'error'  
    //   );
    // }

    //chapterCount
    let oldChapterCount = [...addedChapterCount];
    let subjectIndex = oldChapterCount.findIndex((item: any) => item.hasOwnProperty(keyName));
    oldChapterCount[subjectIndex] = { ...oldChapterCount[subjectIndex], [keyName]: totalValue };
    setchapterCount({ addedChapterCount: [...oldChapterCount] });
};

export const checkDateOverlap = (date: any, phaseId: any,props: any) => {
  const { phases } = props;

  let overlapPhase: any = Object.keys(phases).find((item: any) => {
    //@ts-ignore
    if ( phases[item].startDate !== '' && phases[item].endDate !== '' && phaseId !== phases[item].id &&
      checkBetweenDate(date, phases[item].startDate, phases[item].endDate)
    ) {
     return phases[item].id;
    }
  });
  overlapPhase = overlapPhase !== undefined ? overlapPhase : false;
  return overlapPhase;
};

export const createSubjectState = (subjects: any, isRevision: boolean = false) => {
  let subjectArr: any = [];
  let subVal: any = 0;
  // if(isRevision){
  //   subVal='-';
  // }
  subjects.forEach((element: any) => {
    subjectArr.push({ [element.name]: subVal });
  });
  return subjectArr;
};

export const mergeGoals = (primaryGoal: any, nonPrimaryGoal: any) => {
  const primaryCourseContent: any = primaryGoal.map((obj: any) => JSON.parse(JSON.stringify(obj)));
  const nonPrimaryCourseContent: any = nonPrimaryGoal.map((obj: any) =>
    JSON.parse(JSON.stringify(obj))
  );

  let subjectOffset = 1;
  nonPrimaryCourseContent.forEach((subject: any, index: number) => {
    const subjectIndex = getIndex(primaryCourseContent, subject.name);
    if (subjectIndex === -1) {
      if (index + subjectOffset < primaryCourseContent.length) {
        primaryCourseContent.splice(index + subjectOffset, 0, subject);
        subjectOffset += 1;
      } else {
        primaryCourseContent.push(subject);
      }
    } else {
      let chapterOffset = 1;

      subject.chaptersData.forEach((chapter: any, index: number) => {
        const chapterIndex = getIndexOfChapterInPrimaryGoal(
          primaryCourseContent[subjectIndex].chaptersData,
          chapter.chapData.name
        );
        if (chapterIndex === -1) {
          if (index + chapterOffset < primaryCourseContent[subjectIndex].chaptersData.length) {
            primaryCourseContent[subjectIndex].chaptersData.splice(
              index + chapterOffset,
              0,
              chapter
            );

            chapterOffset += 1;
          } else {
            primaryCourseContent[subjectIndex].chaptersData.push(chapter);
          }
          primaryCourseContent[subjectIndex].chapterCount += 1;
        } else {
          let conceptOffset = 1;
          chapter.chapterConcepts.forEach((concept: any, index: number) => {
            const conceptIndex = getIndexOfConceptInPrimaryGoal(
              primaryCourseContent[subjectIndex].chaptersData[chapterIndex].chapterConcepts,
              concept.name
            );
            if (conceptIndex === -1) {
              if (
                index + conceptOffset <
                primaryCourseContent[subjectIndex].chaptersData[chapterIndex].chapterConcepts.length
              ) {
                primaryCourseContent[subjectIndex].chaptersData[
                  chapterIndex
                ].chapterConcepts.splice(index + conceptOffset, 0, concept);
                conceptOffset += 1;
              } else {
                primaryCourseContent[subjectIndex].chaptersData[chapterIndex].chapterConcepts.push(
                  concept
                );
              }
            }
          });
        }
      });
    }
  });
  return primaryCourseContent;
};

const getIndex = (primaryCourseContent: any, subjectName: string) => {
  const length = primaryCourseContent.length;
  for (let i = 0; i < length; i++) {
    if (primaryCourseContent[i].name === subjectName) return i;
  }

  return -1;
};

const getIndexOfChapterInPrimaryGoal = (primaryChapters: any, chapterName: string) => {
  const length = primaryChapters.length;
  for (let i = 0; i < length; i++) {
    if (primaryChapters[i].chapData.name === chapterName) return i;
  }

  return -1;
};

const getIndexOfConceptInPrimaryGoal = (primaryConcepts: any, conceptName: string) => {
  const length = primaryConcepts.length;
  for (let i = 0; i < length; i++) {
    if (primaryConcepts[i].name === conceptName) return i;
  }

  return -1;
};


export const checkMinimumChapter = (props: any) => {
      const {phases,coursePlanState,showMsg} = props;
      let returnData = false;
      let matchedArr: any = [];
      Object.keys(phases).forEach((item: any) => {
      const { phaseName = "", subject = {}, startDate = "", endDate = "", isRevision } = phases[item];
      let subjectCountArr = createSubjectCountObj(subject,props);
      let phaseWeek = convertPhasesInToWeeks(startDate, endDate, coursePlanState.weekFormat);
      //console.log({phaseWeek:phaseWeek.length},{subjectCountArr},{phases});

        if (!isRevision) {
          let checkPhaseDate= subjectCountArr.find((phaseSub: any) => phaseSub.chapterCount >= phaseWeek.length);
            if(typeof checkPhaseDate === 'undefined'){
              matchedArr.push({phaseName,weeksCount:phaseWeek.length});
            }
        }
      });

      if(matchedArr.length > 0) {
          // showMsg(
          //   `Minimum ${matchedArr[0].weeksCount} chapter should be added in at least one subject in ${matchedArr[0].phaseName}`,
          //   'error'
          // );
      }

      returnData = matchedArr.length > 0 ?false:true;
      return returnData
}

export const checkDuplicatePhaseName = (props: any) => {
  const { phases } = props;
  let checkPhase = false;
  Object.keys(phases).forEach((item: any) => {
    const { phaseName = "", id = "" } = phases[item];

    let checkPhaseDate = Object.keys(phases).find((phaseKey: any) => phases[phaseKey].phaseName.toLowerCase() === phaseName.toLowerCase() && phases[phaseKey].id !== id && phases[phaseKey].phaseName !== "");
   
    if (typeof checkPhaseDate !== 'undefined') {
      checkPhase = true;
    }
  });
  return checkPhase;
}

export const handleChapterSequence = (chapters: any) => {
  let chapterMap = new Map();
  let chapterWithSequence: any = [];
  let chapterWithNoSequence: any = [];
  let finalSortedChapter: any = [];
  chapters && chapters.length && chapters.forEach((item: any) => {

    if (item.hasOwnProperty("sequenceNumber") && item.sequenceNumber && item.sequenceNumber !=="") {
      const sequenceNum = Number(item.sequenceNumber);
      chapterWithSequence.push(sequenceNum);
      chapterMap.set(sequenceNum, item);

    } else {
      chapterWithNoSequence.push(item);
    }
  });

  chapterMap.set("noSequence", chapterWithNoSequence);
  chapterWithSequence.sort((a: any, b: any) => a - b);
  chapterWithSequence && chapterWithSequence.length && chapterWithSequence.forEach((item: any) => {
    const getItem = chapterMap.get(item);
    if (getItem) {
      finalSortedChapter.push(getItem);
    }

  })

  const getNoSeguence = chapterMap.get("noSequence");
  getNoSeguence && getNoSeguence.length && (finalSortedChapter = [...finalSortedChapter, ...getNoSeguence])

  ////console.log({ finalSortedChapter });
  return finalSortedChapter;

}

export const getPhaseStatus = (startDateString: any, endDateString: any): boolean => {
  if(!startDateString || !endDateString) {
    return false;
  }
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const academicYearStartDate = new Date(
    currentDate.getMonth() >= ACADEMIC_YEAR.APRIL_MONTH_INDEX ? currentYear : currentYear - 1,
    ACADEMIC_YEAR.APRIL_MONTH_INDEX,
    ACADEMIC_YEAR.AY_START_DATE
  );
  const academicYearEndDate = new Date(
    academicYearStartDate.getFullYear() + 1,
    ACADEMIC_YEAR.MARCH_MONTH_INDEX,
    ACADEMIC_YEAR.AY_END_DATE
  );
  const startDate = new Date(startDateString);
  return ((startDate >= academicYearStartDate) && (startDate <= academicYearEndDate)) || (startDate < academicYearStartDate);
}
